// =============================================================================
//    (c) Copyright 2017 by LiveWatch Security LLC | Evanston, IL, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 10.11.17
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// Browser hacks and other browser-specific code.
// -----------------------------------------------------------------------------

const BrowserHelper = (($) => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // The Facebook in-app browser has bottom toolbars that unwantingly overlap any
  // `position: fixed;` elements (i.e. modals).
  //
  // This "fix" is by no means a catch-all solution, but rather adds a class
  // and sets a height on the HTML element so that fixes can be applied in the CSS
  // on a case-by-case basis.
  function fbAppViewportFix () {
    if (BrowserHelper.isFacebookApp()) {
      // Add class on HTML tag
      $(document.documentElement).addClass('_fb-app-vp-fix')

      // innerHeight after a timeout is the only reliable measure of the viewable
      // area of the FB browser. Setting <html> to this height lets us
      // accurately position elements relative to <html>
      setTimeout(() => {
        document.querySelector('html').style.height = window.innerHeight + 'px'
      }, 1000)
    }
  }

  function iosFrameTouchEventsFix () {
    if (BrowserHelper.isAppleMobileSafari()) {
      $('.c-frame').attr('ontouchstart', 'return true;')
    }
  }

  /* --------------------------------------------------------------------------
    Public Functions
  -------------------------------------------------------------------------- */

  let BrowserHelper = {
    initAllFixes () {
      fbAppViewportFix()
      iosFrameTouchEventsFix()
    },

    isFacebookApp () {
      return (userAgent.indexOf('FBAN') > -1) || (userAgent.indexOf('FBAV') > -1)
    },

    isAppleMobileSafari () {
      return (userAgent.indexOf('Safari') > -1) && (userAgent.indexOf('iPhone') > -1)
    }
  }

  return BrowserHelper
})(jQuery)

export default BrowserHelper
